// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1xKDI","errorLogs":"EditorFooter_errorLogs__2qtqB"};